<template>
  <card-list
    v-if="isAdmin"
    title="Totales"
    :records="totalesRecords"
    :columns="totalesColumns"
    readonly="true"
    hideFilters="true"
    doNotSort="true"
    unableSelect="true"
    hideHeaders="true"
    hideActions="true"
  />
</template>
<script>
import { mapState } from "vuex";
import CardList from "@/components/Cards/CardList.vue";

// Resumen de totales de un listado de presupuestos. Los importes solo los ve
// admin, y el backend tampoco los emite para el resto de los roles: el v-if de
// aca es presentacion, no el control de acceso.
export default {
  name: "TotalesProyectos",

  components: {
    CardList,
  },

  props: {
    // El meta que devuelve PresupuestoService.list
    meta: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      totalesColumns: [
        { name: "label", type: "STRING" },
        { name: "value", type: "DECIMAL", currency: true },
      ],
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.user,
    }),

    isAdmin() {
      return this.userInfo?.roles?.includes("admin");
    },

    totalesRecords() {
      return [
        { label: "Horas", value: this.meta.totalHoras },
        { label: "Costo interno", value: this.meta.totalCostoInterno },
        { label: "Costo externo", value: this.meta.totalCostoExterno },
        { label: "Costo del proyecto", value: this.meta.totalCostoEngapa },
        { label: "Monto comparativo", value: this.meta.totalMontoComparativo },
      ];
    },
  },
};
</script>
